<template>
  <div class="dialog_content">
    <div class="filtrate">
      <!-- <el-button @click="selectAll">全选</el-button> -->
      <el-input
        v-model="input"
        placeholder="请输入内容"
        style="margin-left:10px;margin-right:10px;width:300px"
      >
        <el-button type="primary" slot="append">搜索</el-button>
      </el-input>
      <!-- <el-button>清空</el-button> -->
    </div>
    <div class="table">
      <div class="all">
        <el-table :data="mallList" height="100%" border>
          <el-table-column :label="menuName">
            <template slot-scope="scope">
              <div class="mallImage">
                <img :src="scope.row.imgUrl" alt="" />
                <div>{{ scope.row.name }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="address"
            label="操作"
            width="100px"
            :key="Math.random()"
          >
            <template slot-scope="scope">
              <el-button
                size="small"
                type="info"
                v-if="scope.row.select"
                disabled
                >已选择</el-button
              >
              <el-button
                size="small"
                @click="selectRow(scope.row, scope.$index)"
                :disabled="flag==1"
                v-if="!scope.row.select"
                >选择</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="selected">
        <el-table :data="selectedList" height="100%" border>
          <el-table-column :label="menuName_s">
            <template slot-scope="scope">
              <div class="mallImage">
                <img :src="scope.row.url" alt="" />
                <div>{{ scope.row.name }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="address" label="数量" width="160" v-if="keys !== 1">
            <template slot-scope="scope">
              <el-input-number
                v-model="scope.row.choseNum"
                @change="handleChange"
                :min="1"
                size="small"
              ></el-input-number>
            </template>
          </el-table-column>
          <el-table-column prop="address" label="操作" width="80">
            <template slot-scope="scope">
              <el-button
                size="small"
                @click="delRow(scope.row.id, scope.$index)"
                type="danger"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="page">
      <div class="left">
        <el-pagination
          layout="prev, pager, next, total, jumper"
          :current-page="page"
          :total="total"
          :page-size="10"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
      <div class="right">
        <el-button @click="closePage()" type="danger">取消</el-button>
        <el-button @click="save()" type="primary">保存</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { getComList } from "@/api/mall"; //商品
import { productList } from "@/api/integralMall"; //积分商品
import { goodsList, vipUserList } from "@/api/vip"; //油品 会员
import { couponList } from "@/api/coupon";
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  props: {
    sList: {
      type: Array,
      default: function() {
        return [];
      }
    },
    jude: {
      // 0 普通商品 1 积分商品 2 优惠券 3 油品
      type: Number,
      default: 0
    },
    judes: {
      //4满减
      type: Number,
      default: 0
    },
    judes: {
      //4满减
      type: Number,
      default: 0
    },
    limit: {
      // 有需求是只选择特定的数量 0 没有限制
      type: Number,
      default: 0
    },
    keys: {
      type: Number,
      default: 0
    },
    menuName: {
      type: String,
      default: "商品"
    }
  },
  watch: {
    sList: {
      handler: function(newVal) {
        this.setInit(newVal);
      },
      deep: true
      // immediate: true
    },
    jude: {
      handler: function(val) {
        this.getComLists();
      },
      deep: true
    },
    menuName(val) {
      this.menuName_s = "已选择" + val;
    }
  },
  data() {
    return {
      choseNum: 1, //选择数
      input: "", //关键字搜索
      page: 1,
      total: 0,
      mallList: [], //全部商品列表
      selectedList: [], //已选择商品列表
      menuName_s: "", //已选择菜单名
      flag:0
    };
  },
  mounted() {
    this.getComLists();
    this.menuName_s = "已选择" + this.menuName;
  },
  methods: {
    // 新增数量选择
    handleChange(value) {
      console.log(value);
    },
    //选择一
    selectRow(row, index) {
      if(this.keys == 1){
        console.log('xuanze',row,index)
        this.flag = 1
      }
      console.log(row);
      // 新增一个数量限制的判断
      if (this.limit) {
        if (this.selectedList.length == this.limit) {
          this.$message.warning("选择已达到数量限制！！！请勿再添加！！");
          return;
        }
      }
      this.mallList[index].select = true;
      console.log(this.mallList[index]);
      var data = {
        id: row.id,
        name: row.name,
        url: row.imgUrl,
        choseNum: row.choseNum
      };
      this.selectedList.push(data);
    },
    //删除一
    delRow(id, index) {
      if(this.keys == 1){
        this.flag = 0
      }
      this.mallList.forEach(item => {
        if (item.id == id) {
          item.select = false;
        }
      });
      this.selectedList.splice(index, 1);
    },
    //保存
    save() {
      console.log(this.selectedList);
      this.$emit("getCommod", this.selectedList);
    },
    closePage() {
      // this.selectedList = [];
      this.page = 1;
      this.getComLists();
      this.$emit("close");
    },
    handleCurrentChange(p) {
      this.page = p;
      this.getComLists();
    },
    //获取商品列表
    getComLists() {
      let data = {
        token: this.token,
        app_id: this.app_id,
        page: this.page
      };
      this.mallList = [];
      if (this.jude == 0) {
        getComList(data).then(res => {
          let data = res.data;
          for (var i = 0; i < data.length; i++) {
            let obj = {};
            obj.name = data[i].name;
            obj.imgUrl = data[i].image[0].url;
            obj.id = data[i].id;
            this.mallList.push(obj);
          }
          this.total = res.total;
          //处理已选择
          this.mallList.forEach(item => {
            item.select = false;
            this.selectedList.forEach(n => {
              if (n.id == item.id) {
                item.select = true;
              }
            });
          });
        });
      } else if (this.jude == 1) {
        productList(data).then(res => {
          this.total = res.data.total_num;
          let data = res.data.result;
          console.log("积分商城", res);
          for (var i = 0; i < data.length; i++) {
            let obj = {};
            obj.name = data[i].title;
            obj.imgUrl = data[i].pic;
            obj.id = data[i].id;
            this.mallList.push(obj);
          }
          //处理已选择
          this.mallList.forEach(item => {
            item.select = false;
            this.selectedList.forEach(n => {
              if (n.id == item.id) {
                item.select = true;
              }
            });
          });
        });
      } else if (this.jude == 2) {
        //选择优惠券
        // 筛选没有过期的优惠券
        data.is_exp = 0;
        if(this.judes == 4){
          data.type = 1
        }
        couponList(data).then(res => {
          console.log('type',res)
          this.total = res.data.total_num;
          let data = res.data.result;
          for (var i = 0; i < data.length; i++) {
            let obj = {};
            obj.name = data[i].title;
            obj.imgUrl = data[i].share_pic;
            obj.id = data[i].id;
            // 新增數量
            obj.choseNum = 1;
            if(data[i].stock!=0){
              this.mallList.push(obj);
            }
          }
          //处理已选择
          this.mallList.forEach(item => {
            item.select = false;
            this.selectedList.forEach(n => {
              if (n.id == item.id) {
                item.select = true;
              }
            });
          });
          this.setInit(this.sList);
        });
      } else if (this.jude == 3) {
        //选择油品
        goodsList(data).then(res => {
          this.total = res.data.total_num;
          let data = res.data;
          console.log("选择油品", res);
          for (var i = 0; i < data.length; i++) {
            let obj = {};
            obj.name = data[i].name;
            obj.imgUrl = "";
            obj.id = data[i].id;
            this.mallList.push(obj);
          }
          // //处理已选择
          this.mallList.forEach(item => {
            item.select = false;
            this.selectedList.forEach(n => {
              if (n.id == item.id) {
                item.select = true;
              }
            });
          });
        });
      } else if (this.jude == 4) {
        vipUserList(data).then(res => {
          this.total = res.data.total_num;
          let data = res.data.result;
          for (var i = 0; i < data.length; i++) {
            let obj = {};
            obj.name = data[i].real_name;
            obj.imgUrl = data[i].headimgurl;
            obj.id = data[i].uid;
            this.mallList.push(obj);
          }
          //处理已选择
          this.mallList.forEach(item => {
            item.select = false;
            this.selectedList.forEach(n => {
              if (n.id == item.id) {
                item.select = true;
              }
            });
          });
        });
      }
    },
    // 处理已选择
    setSelected() {
      this.mallList.forEach(item => {
        item.select = false;
        this.selectedList.forEach(n => {
          if (n.id == item.id) {
            item.select = true;
          }
        });
      });
    },
    setInit(newVal) {
      console.log("传入已选商品列表", newVal);
      this.selectedList = [];
      newVal.forEach((item, index) => {
        item.imgUrl = item.url;
        this.selectRow(item, index);
      });
      this.setSelected();
    }
  }
};
</script>

<style lang="scss" scoped>
.dialog_content {
  width: 100%;
  padding: 0;
  .filtrate {
    text-align: right;
  }
  .table {
    margin-top: 10px;
    height: 450px;
    display: flex;
    .all {
      width: 40%;
    }
    .selected {
      width: 60%;
      padding-left: 15px;
    }
    .mallImage {
      display: flex;
      flex-direction: row;
      img {
        width: 50px;
        height: 50px;
      }
      div {
        flex: 1;
        margin-left: 10px;
        line-height: 50px;
      }
    }
  }
  .page {
    margin-top: 5px;
    height: 30px;
    display: flex;
    .left {
      flex: 1;
    }
    .right {
      margin-left: 10px;
    }
  }
}
</style>
